<mat-label class="label text-xxs color-gray14">{{ label }} </mat-label>
<form>
    <mat-chip-grid #chipGrid [attr.aria-label]="label">
        @for (selected of selectedOptions(); track $index) {
            <mat-chip-row
                [class.chip--invalid]="selected.invalid"
                (removed)="remove(selected)">
                <span class="flex items-center">
                    @if (selected.invalid) {
                        <mat-icon
                            svgIcon="warning-circle"
                            class="mr-2"
                            [style.width]="'16px'" />
                    }
                    {{ selected.viewValue }}
                </span>
                <button matChipRemove [attr.aria-label]="'remove ' + selected">
                    <mat-icon svgIcon="close" />
                </button>
            </mat-chip-row>
        }
    </mat-chip-grid>
    <input
        #input
        name="current"
        class="w-full h-full"
        [placeholder]="placeholder"
        [(ngModel)]="current"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputAddOnBlur]="true"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)" />
    <mat-autocomplete
        #auto="matAutocomplete"
        autoActiveFirstOption
        (optionSelected)="selected($event); input.value = ''">
        @if (isGroupedOptions) {
            @for (option of filteredGroupOptions(); track option.group) {
                @if (option.items.length > 0) {
                    <mat-optgroup [label]="option.group">
                        @for (item of option.items; track item.value) {
                            <mat-option
                                [value]="item"
                                [disabled]="
                                    isOptionDisabled(item.value) ||
                                    item.disabled
                                "
                                class="option">
                                @if (item.disabled) {
                                    <div class="disabled-option">
                                        <span> {{ item.viewValue }} </span>
                                        <div class="flex items-center">
                                            <span class="text-xxs"
                                                >Inactive</span
                                            >
                                            <app-tooltip
                                                style="pointer-events: auto">
                                                <mat-icon
                                                    trigger
                                                    svgIcon="info" />
                                                <ul content class="pl-4">
                                                    <li>
                                                        This user is marked as
                                                        “inactive” therefore can
                                                        not be assigned to
                                                        discrepancies.
                                                    </li>
                                                </ul>
                                            </app-tooltip>
                                        </div>
                                    </div>
                                } @else {
                                    {{ item.viewValue }}
                                }
                            </mat-option>
                        }
                    </mat-optgroup>
                }
            }
        } @else {
            @for (option of filteredOptions(); track option) {
                <mat-option
                    [value]="option"
                    [disabled]="isOptionDisabled(option.value)">
                    {{ option.viewValue }}
                </mat-option>
            }
        }
        @if (noResult) {
            <mat-option disabled>No matching results.</mat-option>
        }
    </mat-autocomplete>
</form>
